module.exports = __webpack_public_path__ + "static/media/screenpromote.effb29af.png";